import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Layout, Breadcrumb} from 'antd';

const { Content } = Layout;

class Market extends Component {
  render() {
    return(
      <Content style={{
          margin: '0 16px'
        }}>
        <Breadcrumb style={{
            margin: '16px 0'
          }}>
          <Breadcrumb.Item><Link to="/market">The Market</Link></Breadcrumb.Item>
          <Breadcrumb.Item><Link to="/market/assets">Assets</Link></Breadcrumb.Item>
          <Breadcrumb.Item>Asset</Breadcrumb.Item>
        </Breadcrumb>
        <div style={{
            padding: 24,
            background: '#fff',
            minHeight: 360
          }}>
          Bill is a cat.
        </div>
      </Content>);
  }
}

export default Market;



// WEBPACK FOOTER //
// ./src/containers/Market/Market.js